<template>
  <transition name="fade">
    <v-container
      v-if="viewbarEnabled"
      fluid
      class="secondary pt-0 pb-0 viewbar"
    >
      <v-row>
        <v-col class="text-center caption font-weight-black">
          Viewing as:
          {{
            impersonating.dealerFullName
              ? impersonating.dealerFullName
              : impersonating.name
          }}
          <v-divider
            vertical
            color="black"
            class="mx-4 hidden-sm-and-down"
          ></v-divider>
          <v-btn text small class="primary mt-n2" @click="toggleView"
            >Logout</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ViewBar",
  methods: {
    ...mapGetters("viewBar", ["viewbarEnabled", "impersonating"]),

    toggleView() {
      let vm = this;

      vm.revokeImpersonation().then(() => {
        vm.SET_EXTENSIONS([]);
        vm.SET_SERVICE_FLAGS([]);
        vm.toggleViewBar();
        vm.resetImpersonation();
        window.location.href = "/";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.viewbar {
  position: fixed;
  top: 0;
  z-index: 9;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
